import clsx from 'clsx';
import type { FC } from 'react';

import { authHeaderWrapper } from './share.css';
import { ThemedLogo } from './themed-logo';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
}> = ({ title, subTitle, className }) => {
  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '8px',
        }}
      >
        <ThemedLogo />
      </div>
      <p>{title}</p>
      {subTitle && <p>{subTitle}</p>}
    </div>
  );
};
